<div class="cart-actions">
  <sd-cart-action-share></sd-cart-action-share>
  <sd-cart-action-clear></sd-cart-action-clear>
</div>
